import React, { Component } from "react";
import { connect } from "react-redux";
import _, { extend } from "lodash";
import moment from "moment";
import { DISPLAY_LOCAL_DATE_FORMAT } from "Constants";
import LocaleStrings from "Languages";

class CommentList extends Component {
  constructor(props) {
    super(props);
  }

  renderHeaders = () => {
    let { settingData, singleSessionCheckouForm } = this.props;
    let formItems =
      settingData &&
      settingData.length > 0 &&
      settingData[0].event_forms_by_sesseionratingformid
        ? JSON.parse(
            settingData[0].event_forms_by_sesseionratingformid.formjson
          )
        : [];

    if (singleSessionCheckouForm.data.sessionratingid) {
      formItems = JSON.parse(
        singleSessionCheckouForm.data.event_forms_by_sessionratingid.formjson
      );
    }

    var headerArr = [];
    if (formItems.length > 0) {
      _.map(formItems, (item, index) => {
        var key = item.key;

        if (key !== "hyperlink" && key !== "label" && key !== "paragraph") {
          headerArr.push(<th key={`header_key_${index}`}>{item.label}</th>);
        }
      });
    }

    return (
      <tr>
        <th>{LocaleStrings.polls_qa_rating_th_commentedby}</th>
        {headerArr}
      </tr>
    );
  };

  renderList = () => {
    let { singleSessionRatings, settingData, singleSessionCheckouForm } =
      this.props;
    let formItems =
      settingData &&
      settingData.length > 0 &&
      settingData[0].event_forms_by_sesseionratingformid
        ? JSON.parse(
            settingData[0].event_forms_by_sesseionratingformid.formjson
          )
        : [];
    if (singleSessionCheckouForm.data.sessionratingid) {
      formItems = JSON.parse(
        singleSessionCheckouForm.data.event_forms_by_sessionratingid.formjson
      );
    }

    let savedForm =
      singleSessionRatings &&
      singleSessionRatings.resource &&
      singleSessionRatings.resource.length > 0
        ? singleSessionRatings.resource
        : [];

    if (savedForm.length > 0) {
      return _.map(savedForm, (item, index) => {
        let responses =
          item.response && item.response != "" ? JSON.parse(item.response) : [];
        return (
          <Items
            key={`key_comment-${index}`}
            printList={responses}
            sessionForm={formItems}
            appuser={item.appuser_by_appuserid}
          />
        );
      });
    }
  };

  render() {
    let { printList, sessionForm, appuser } = this.props;
    let filter = _.filter(printList, (obj) => {
      return obj.key == "textinput" && obj.name == "comment";
    });

    return (
      <div className="sponsor-table overflow-auto">
        <table className="table">
          <thead>{this.renderHeaders()}</thead>
          <tbody className="tbody-background">{this.renderList()}</tbody>
        </table>
      </div>
    );
  }
}

export var mapStateToProps = (state) => {
  return {
    session: state.session,
    settingData: state.SettingData.resource,
    singleSessionCheckouForm: state.singleSessionCheckouForm,
    singleSessionRatings: state.singleSessionRatings,
  };
};
export default connect(mapStateToProps, {})(CommentList);

class Items extends Component {
  renderList = () => {
    let { printList, sessionForm } = this.props;

    return _.map(sessionForm, (form, index) => {
      var key = form.key;

      if (key !== "hyperlink" && key !== "label" && key !== "paragraph") {
        let filter = _.filter(printList, (obj) => {
          return obj.name == form.name;
        });

        var value = "-";
        if (filter.length > 0) {
          value = filter[0].value;

          if (value === "" || value == 0 || value == "0.0") value = "-";
          else value = value;

          if (key === "dropdown" || key === "dropdown") {
            var options = form.options;
            var checkValue = _.filter(options, function (opt) {
              return opt.text === value || opt.value === value;
            });

            value = checkValue.length > 0 ? checkValue[0].text : "-";
          }

          if (key === "checkboxes") {
            var options = form.options;

            var displayValue = [];
            _.map(value, (box) => {
              var checkValue = _.filter(options, function (opt) {
                return opt.text === box || opt.value === box;
              });

              if (checkValue && checkValue.length > 0) {
                displayValue.push(checkValue[0].text);
              }
            });

            value = displayValue.length > 0 ? displayValue.join(",") : "-";
          }

          if (key === "rating" && value) {
            value = value !== "-" ? parseInt(value) : value;
          }

          if (key === "datepicker") {
            var timestamp = Date.parse(value);
            if (isNaN(timestamp) == false) {
              value = moment(timestamp).format(DISPLAY_LOCAL_DATE_FORMAT);
            } else {
              value = "-";
            }
          }
        }

        return (
          <td key={`td_ke_${index}`}>
            <div className="vcenter">{value}</div>
          </td>
        );
      }
    });
  };

  render() {
    let { appuser } = this.props;

    return (
      <tr>
        <td>
          <div className="vcenter">
            {appuser.username ? appuser.username : "Anonymous"}
          </div>
        </td>
        {this.renderList()}
      </tr>
    );
  }
}
